import React from 'react'
import { object, string } from 'prop-types'

import { Row, Col } from 'components/qstrap'

import { RiasecChart } from  'components/atoms/Chart'
import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'
import RIASECBox from 'components/atoms/RIASECBox'

const AptitudeResult = ({ comment, ratio }) => {
  const sortedKey = ratio && Object.keys(ratio).sort((a, b) => ratio[b].value - ratio[a].value).map(key => key)
  return (
    <div className="aptitude-result">
      <SectionContainer
        paddingTop={80}
        backgroundColor="transparent"
      >
        <Container>
          <Typography component="h2" variant="title" className="text-variant-title-sm font-bolder text-center">Kamu Termasuk Tipe yang Mana?</Typography>
          <Row className="aptitude-result__riasec">
            <Col md="5">
              {
                ratio && Object.entries(ratio).map(([key, value]) => (
                  <RIASECBox
                    label={key}
                    score={value.value}
                    text={value.text}
                    sortedKey={sortedKey}
                    key={`riasec-${key}`}
                  />
                ))
              }
            </Col>
            <Col md="7">
              <RiasecChart ratioData={ratio} />
            </Col>
          </Row>
          <Typography component="p" variant="body">{comment}</Typography>
        </Container>
      </SectionContainer>
      <Container div className="aptitude-result__wrapper">
        <div className="aptitude-result__recommendation">
          <Typography component="h4" variant="headline" className="font-bolder">Rekomendasi</Typography>
          <Typography component="p" variant="note">Berdasarkan hasil RIASEC ini, kamu bisa menemukan karier apa saja yang sesuai dengan kepribadianmu. Setiap karier akan mempunyai kriteria kemampuan yang bermacam-macam. Kamu bisa mempersiapkan diri sesuai dengan karier yang kamu cita-citakan. Bagi kamu yang belum memiliki gambaran karier yang kamu inginkan, kamu juga bisa melihat jurusan yang sesuai dengan kepribadianmu. Tidak perlu khawatir, karena setiap jurusan mempunyai peluang karier yang beragam! Jadi, kamu bisa menentukan langkah karier kamu setelah kamu kuliah di jurusan tersebut. Semoga sukses ya, Quipperian!</Typography>
        </div>
      </Container>
      <style jsx>
        {`
          .aptitude-result {
            background-color: #f5fcff;
            :global(.campus-section) {
              @media screen and (max-width: 767px) {
                padding-top: 40px;
              }
            }
            :global(&__wrapper) {
              position: relative;
              padding: 100px;
              @media screen and (max-width: 767px) {
                padding: 200px;
              }
            }
            :global(&__riasec) {
              margin: 64px 0 !important;
              @media screen and (max-width: 767px) {
                margin: 30px 0 !important;
              }
            }
            &__recommendation {
              position: absolute;
              top: 50px;
              margin: 0 50px;
              padding: 20px 30px;
              background-color: #fff;
              box-shadow: 0 6px 16px 0 rgba(107, 143, 188, 0.1);
              :global(p) {
                font-size: 12px !important;
              }
              :global(p, h4) {
                color: #0c2846 !important;
              }
              @media screen and (max-width: 767px) {
                margin: 0 10px;
                left: 0px;
                top: 50px;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

AptitudeResult.propTypes = {
  comment: string,
  ratio: object,
}

export default AptitudeResult
